import { z } from "zod";

/**
 * ORTAK İPTAL/YENİDEN ATAMA ÇEKİRDEĞİ — konfig (CLOS-233 `[170]` DEV-174, CLOS-922).
 *
 * ⚠ AÇIK KARAR (kartın kendi cümlesi): *"hangi terminal/aktif durumlarda iptal veya
 * yeniden atama yapılabileceği, gerekçe zorunluluğu ve riskli işlemlerde ek onay politikası
 * workflow türüne göre sürümlenir."* Gerekçe zorunluluğu bu yüzden KOD SABİTİ değil,
 * tür başına ayrı konfig satırı — inceleme (`[150]` CLOS-157) ve onay (`[152]` CLOS-159)
 * kartlarının "değişiklik/ret gerekçesi zorunlu mu" desenini iptal/yeniden atama için
 * tekrarlıyor.
 *
 * ⚠ Dört tür TEK dosyada: hepsi aynı ortak çekirdeği (CLOS-922) kullanıyor ve tek bir
 * "gerekçe ne zaman zorunlu" sorusuna cevap veriyorlar. Ayrı dosyalara bölseydik dört
 * yükleyici aynı asgari uzunluk sabitini dört kez taşırdı.
 */
export const WORKFLOW_CANCEL_REASSIGN_TYPES = [
  "review",
  "approval",
  "negotiation",
  "signature",
] as const;
export type WorkflowCancelReassignType = (typeof WORKFLOW_CANCEL_REASSIGN_TYPES)[number];

const turPolitikasi = z.object({
  /** Bu türde görev/akış İPTALİ için gerekçe zorunlu mu. */
  requireReasonForCancel: z.boolean(),
  /** Bu türde YENİDEN ATAMA için gerekçe zorunlu mu. */
  requireReasonForReassign: z.boolean(),
});

export const workflowCancelReassignConfigSchema = z.object({
  version: z.literal(1),
  /** Gerekçe YAZILDIĞINDA asgari uzunluğu — tür fark etmeksizin tek eşik. */
  reasonMinLength: z.number().int().min(0),
  types: z.object({
    review: turPolitikasi,
    approval: turPolitikasi,
    negotiation: turPolitikasi,
    signature: turPolitikasi,
  }),
});
export type WorkflowCancelReassignConfig = z.infer<typeof workflowCancelReassignConfigSchema>;
